import { css } from 'styled-components';

export const PEARL_CONNECT_ACCENT = '#2b4344';

export const PEARL_CONNECT_FIELD_RADIUS = '8px';

export const PEARL_CONNECT_FIELD_STROKE = '#dcdcdc';

const PEARL_ERROR = '#d32f2f';

const fieldShell = 'div[class*="-container"]:not(.menu-container):not(.toggle-switch-container)';

export const pearlConnectFormFieldOverrides = css`
    ${fieldShell} {
        border-radius: ${PEARL_CONNECT_FIELD_RADIUS} !important;
        /* visible: floating labels sit at top: -6px; hidden clips them so the inset border reads through text */
        overflow: visible !important;
    }

    /* TextInput: BorderLabel is direct child div.p4. Dropdown: BorderLabel inside .input-wrapper */
    ${fieldShell} > div.p4,
    ${fieldShell} .input-wrapper > div.p4 {
        z-index: 2 !important;
    }

    ${fieldShell}:not(.is-focused):not(.is-invalid):not(.is-disabled) {
        box-shadow: inset 0 0 0 1px ${PEARL_CONNECT_FIELD_STROKE} !important;
    }

    ${fieldShell}.is-focused:not(.is-invalid) {
        box-shadow: inset 0 0 0 1px ${PEARL_CONNECT_ACCENT} !important;
    }

    ${fieldShell}.is-focused.is-invalid {
        box-shadow: inset 0 0 0 2px ${PEARL_ERROR} !important;
    }

    ${fieldShell}.is-focused:not(.is-invalid) span:first-child {
        color: ${PEARL_CONNECT_ACCENT} !important;
    }

    /* Floating label typography (ui-kit .p4) is not always the first span — override pink focus color. */
    ${fieldShell}.is-focused:not(.is-invalid) .p4 {
        color: ${PEARL_CONNECT_ACCENT} !important;
    }

    ${fieldShell}.is-focused:not(.is-invalid) label {
        color: ${PEARL_CONNECT_ACCENT} !important;
    }

    ${fieldShell}.is-focused.is-invalid span:first-child {
        color: ${PEARL_ERROR} !important;
    }

    ${fieldShell}.is-focused.is-invalid .p4 {
        color: ${PEARL_ERROR} !important;
    }

    ${fieldShell}.is-focused.is-invalid label {
        color: ${PEARL_ERROR} !important;
    }

    ${fieldShell} input:focus,
    ${fieldShell} input:focus-visible {
        outline: none !important;
    }

    select {
        border-radius: ${PEARL_CONNECT_FIELD_RADIUS} !important;
    }

    select:not(:focus):not(.is-invalid) {
        box-shadow: inset 0 0 0 1px ${PEARL_CONNECT_FIELD_STROKE} !important;
    }

    select.is-invalid:not(:focus) {
        box-shadow: inset 0 0 0 2px ${PEARL_ERROR} !important;
    }

    select:focus:not(.is-invalid) {
        box-shadow: inset 0 0 0 1px ${PEARL_CONNECT_ACCENT} !important;
    }

    select:focus.is-invalid {
        box-shadow: inset 0 0 0 2px ${PEARL_ERROR} !important;
    }

    select:focus {
        outline: none !important;
    }
`;

export const pearlConnectCategoryAndSubcategoryOverrides = css`
    /* BorderLabelContainer defaults to theme foreground.base (dark); match other inputs (#dcdcdc). */
    .menu-container {
        border-radius: ${PEARL_CONNECT_FIELD_RADIUS} !important;
        overflow: visible !important;
        border: 1px solid ${PEARL_CONNECT_FIELD_STROKE} !important;
    }

    .menu-container .border-label {
        z-index: 2 !important;
    }

    /* Teal ring only while the category list is open (selected / active). */
    .is-open .menu-container {
        border: none !important;
        box-shadow: inset 0 0 0 1px ${PEARL_CONNECT_ACCENT} !important;
    }

    .miniSubCatList .list-items > div.is-checked {
        border-color: ${PEARL_CONNECT_ACCENT} !important;
    }

    .miniSubCatList .list-items > div.is-checked .check {
        border-color: ${PEARL_CONNECT_ACCENT} !important;
        background-color: ${PEARL_CONNECT_ACCENT} !important;
    }
`;
